var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3773_17039",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 17,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    width: 40,
    height: 40,
    fill: "#1C1B1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3773_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 36.7368C34.4875 36.7368 33.2329 36.2282 32.2363 35.2109C31.2391 34.1931 30.7405 32.9123 30.7405 31.3684C30.7405 29.8246 31.2391 28.544 32.2363 27.5267C33.2329 26.5089 34.4875 26 36 26C37.5125 26 38.7671 26.5089 39.7637 27.5267C40.7609 28.544 41.2595 29.8246 41.2595 31.3684C41.2595 32.9123 40.7609 34.1931 39.7637 35.2109C38.7671 36.2282 37.5125 36.7368 36 36.7368ZM25 48V44.4918C25 43.6261 25.2118 42.8716 25.6353 42.2282C26.0593 41.5848 26.6151 41.0995 27.3026 40.7722C28.7926 40.0705 30.2537 39.5382 31.686 39.1756C33.1182 38.8129 34.5562 38.6316 36 38.6316C37.4438 38.6316 38.876 38.8129 40.2967 39.1756C41.7179 39.5382 43.1848 40.0705 44.6974 40.7722C45.3849 41.1231 45.9404 41.6143 46.3639 42.2459C46.788 42.8775 47 43.6261 47 44.4918V48H25ZM27.3026 45.6497H44.6974V44.4918C44.6974 44.1639 44.6055 43.8481 44.4218 43.5444C44.2387 43.2401 44.0096 43.0178 43.7346 42.8775C42.3364 42.1757 41.0244 41.6845 39.7984 41.4038C38.5724 41.1231 37.3063 40.9827 36 40.9827C34.6937 40.9827 33.4218 41.1231 32.1843 41.4038C30.9467 41.6845 29.6405 42.1757 28.2654 42.8775C27.9673 43.0178 27.7325 43.2401 27.5609 43.5444C27.3887 43.8481 27.3026 44.1639 27.3026 44.4918V45.6497ZM36 34.4211C36.8481 34.4211 37.5585 34.1288 38.131 33.5444C38.7041 32.9594 38.9907 32.2341 38.9907 31.3684C38.9907 30.5033 38.7041 29.7782 38.131 29.1933C37.5585 28.6083 36.8481 28.3158 36 28.3158C35.1519 28.3158 34.4415 28.6083 33.869 29.1933C33.2959 29.7782 33.0093 30.5033 33.0093 31.3684C33.0093 32.2341 33.2959 32.9594 33.869 33.5444C34.4415 34.1288 35.1519 34.4211 36 34.4211Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorIcon);
export default __webpack_public_path__ + "static/media/mentor-icon.e66298479b3d9e8214fb365da132b798.svg";
export { ForwardRef as ReactComponent };